import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.scss';

const MyBiyesadi = () => {
  const links = [
    { to: '/my-biyesadi/', label: 'Dashboard' },
    { to: '/my-biyesadi/profile', label: 'Profile' },
    { to: '/my-biyesadi/photos', label: 'Photo' },
    { to: '/my-biyesadi/partner-preference', label: 'Partner Preference' },
    { to: '/my-biyesadi/settings', label: 'Settings' },
    { to: '/my-biyesadi/contact', label: 'Contact Details' },
    { to: '/my-biyesadi/package', label: 'Packages' },
    { to: '/my-biyesadi/paymentlog', label: 'Payment Log' },
  ];

  return (
    <div className="custom-navbar">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-wrap justify-content-start gap-2">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                className={({ isActive }) =>
                  isActive ? 'btn shadow-sm isActive' : 'btn shadow-sm'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBiyesadi;
